import { STRIPE_MAX_INTERVAL_COUNT } from '#validation/billing/constants';
import { positiveInt } from '#validation/partner-organization';
export const intervalCount = positiveInt.max(STRIPE_MAX_INTERVAL_COUNT);
